import './style.css'
import { LoveMessageService } from './services/loveMessageService.js'

document.addEventListener('DOMContentLoaded', () => {
    const loveService = new LoveMessageService();
    const generateButton = document.getElementById('generate-button');
    const nameInput = document.getElementById('partner-name');
    const styleSelect = document.getElementById('style-select');
    const resultsContainer = document.getElementById('results-container');
    const loadingIndicator = document.getElementById('loading-indicator');

    generateButton?.addEventListener('click', async () => {
        const name = nameInput.value.trim();
        const style = styleSelect.value;

        if (!name) {
            alert('请输入对方的名字');
            return;
        }

        try {
            resultsContainer.innerHTML = `
                <div class="generating-message">
                    正在为您生成情话...
                </div>
            `;
            
            const messages = await loveService.generateLoveMessages(name, style);
            
            if (Array.isArray(messages) && messages.length > 0) {
                displayResults(messages);
            } else {
                throw new Error('生成结果格式错误');
            }
        } catch (error) {
            console.error('Error:', error);
            resultsContainer.innerHTML = `
                <div class="love-message-result error">
                    <div class="love-message-content">
                        ${error.message || '生成失败，请稍后重试'}
                    </div>
                </div>
            `;
        }
    });

    function displayResults(messages) {
        if (!resultsContainer) return;
        resultsContainer.innerHTML = messages.map(msg => `
            <div class="love-message-result animate-fade-in">
                <div class="love-message-header">
                    <span class="source-tag">${msg.source}</span>
                    <span class="score-badge ${getScoreClass(msg.score)}">
                        评分: ${msg.score}/10
                    </span>
                </div>
                <div class="love-message-content">
                    ${msg.content}
                </div>
                <div class="love-message-meta">
                    <div>
                        <strong>适用场景:</strong> ${msg.scenario}
                    </div>
                    <div>
                        <strong>情感分析:</strong> ${msg.analysis}
                    </div>
                    <div>
                        <strong>使用建议:</strong> ${msg.suggestion}
                    </div>
                </div>
            </div>
        `).join('');
    }

    function getScoreClass(score) {
        if (score >= 8) return 'score-high';
        if (score >= 6) return 'score-medium';
        return 'score-low';
    }
}); 